import React from 'react';

const CareerCard = ({ title, variant, selected, onClick, description }) => {
  const isFilled = variant === 'filled';

  return (
    <div
      onClick={onClick}
      role="radio"
      aria-checked={selected}
      tabIndex={0}
      className={`cursor-pointer w-full 
        ${isFilled ? 'max-w-[280px] sm:max-w-[360px]' : 'max-w-[280px] sm:max-w-[320px]'} 
        p-4 rounded-2xl flex flex-col gap-2 border-2 shadow-sm transition-all duration-200
        ${isFilled ? 'bg-[#FFB3BA]/40 border-black' : 'bg-white border-black'}
        ${selected ? 'ring-2 ring-orange-500 scale-[1.02]' : 'hover:shadow-md'}
        focus:outline-none focus:ring-2 focus:ring-orange-400
      `}
    >
      {/* Custom radio icon */}
      <div className="w-5 h-5 relative">
        <div
          className={`w-4 h-4 absolute top-[2px] left-[2px] rounded-full border-[3px] transition-all duration-200 
            ${selected ? 'border-red-600 bg-red-600' : 'border-red-600 bg-transparent'}
          `}
        />
      </div>

      {/* Career Title */}
      <div
        className={`text-[#221C1B] font-syne leading-snug whitespace-pre-wrap
          ${isFilled ? 'font-medium text-xs sm:text-sm' : 'font-bold text-xs sm:text-sm'}
        `}
      >
        {title}
      </div>

      {/* Dynamic Description from GPT */}
      {description && (
        <div className="text-gray-600 text-xs mt-1 leading-tight font-syne whitespace-pre-wrap">
          {description}
        </div>
      )}
    </div>
  );
};

export default CareerCard;
